module.exports = __webpack_public_path__ + "static/img/10.7dddd52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/10.png
// module id = eUZh
// module chunks = 0